import { createFileRoute } from "@tanstack/react-router"
import { DataPage } from "@/features/crawl-dashboard/DataPage"
import {
	type CrawlDataSearch,
	crawlDataSearchSchema,
} from "@/features/crawl-dashboard/data-search"

export const Route = createFileRoute("/crawl/data")({
	component: CrawlDataRoute,
	validateSearch: (search: Record<string, unknown>) =>
		crawlDataSearchSchema.parse(search),
})

function CrawlDataRoute() {
	const search = Route.useSearch()
	const navigate = Route.useNavigate()

	const onSearchChange = (patch: Partial<CrawlDataSearch>) => {
		navigate({ search: (previous) => ({ ...previous, ...patch }) })
	}

	return <DataPage search={search} onSearchChange={onSearchChange} />
}
